import React, { useState } from 'react'
import styled from 'styled-components'

// components
import { Rating } from '../components'
import Paging from '../../../components/pagination/Paging'

// styles
import colors from '../../../styles/colors'

const ReviewItem = ({
  filterItem,
  total,
  page,
  setPage,
  onDeleteComment,
  onAddComment,
}) => {
  const [isEdit, setIsEdit] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const [comment, setComment] = useState('')
  const [focusIdx, setFocusIdx] = useState(null)

  const onClickCancel = () => {
    onReset()
  }

  const onChangeComment = (input, targetIdx) => {
    setSelectedIndex(targetIdx)
    setComment(input)
  }

  const checkingEdit = (isModify, isSelect) => {
    // 미답변 분류
    // 1. ownerComment - null
    // 2. ownerComment - '삭제된 댓글입니다.' && ownerCommentDate

    if ((!isEdit && isModify) || (isEdit && !isSelect)) {
      return true
    } else {
      return false
    }
  }

  const onReset = () => {
    setIsEdit(false)
    setSelectedIndex(-1)
    setComment('')
  }

  const onFocusInput = (idx) => {
    setFocusIdx(idx)
  }

  const changePage = (page) => {
    setPage(page)
  }

  return (
    <>
      <ReviewContainer>
        {filterItem &&
          filterItem.map((ele, idx) => (
            <ReviewWrapper
              key={idx}
              isFirst={idx === 0}
              isLast={filterItem.length === idx + 1}
            >
              <ContentsWrapper>
                <InfoWrapper>
                  <WriterInfo>{ele.name}</WriterInfo>
                  <StarTimeInfo>
                    <div>
                      <Rating score={ele.avgScore} />
                    </div>
                    <TimeInfoMo>{ele.userCommentDate}</TimeInfoMo>
                  </StarTimeInfo>
                  <MenuInfo>{ele.itemName}</MenuInfo>
                  <TimeInfo>{ele.userCommentDate}</TimeInfo>
                </InfoWrapper>

                <CommentWrapper>
                  <UserComment>{ele.userComment}</UserComment>
                  <OwnerComment>
                    {/* {checkingEdit(ele.ownerComment, selectedIndex === idx) ? ( */}
                    {checkingEdit(
                      ele.ownerComment &&
                        ele.ownerComment !== '삭제된 댓글입니다.',
                      selectedIndex === idx,
                    ) ? (
                      <PrintReview>
                        <TextPrintReview>{ele.ownerComment}</TextPrintReview>
                        <TimePrintReview>
                          {ele.ownerCommentDate}
                        </TimePrintReview>
                      </PrintReview>
                    ) : (
                      <InputReview>
                        <TextInputReview
                          placeholder={'답변을 입력해주세요.'}
                          value={selectedIndex === idx ? comment : ''}
                          maxLength={1000}
                          focusIdx={focusIdx === idx}
                          onChange={(e) => onChangeComment(e.target.value, idx)}
                          onFocus={() => onFocusInput(idx)}
                          onBlur={() => {
                            setFocusIdx(null)
                            // setComment('')
                          }}
                          // onBlur={() => setFocusIdx(null)}
                        />

                        <InfoInputReview
                          isFocus={focusIdx === idx && comment.length > 0}
                        >
                          <span>
                            최소 10자 이상, 최대 1,000자 이하까지 작성 가능
                          </span>

                          <span>
                            {focusIdx === idx ? (
                              <LimitWrapper>
                                <h1>{comment.length}</h1>/1,000자
                              </LimitWrapper>
                            ) : (
                              '0/1,000자'
                            )}
                          </span>
                        </InfoInputReview>
                      </InputReview>
                    )}
                  </OwnerComment>
                </CommentWrapper>
              </ContentsWrapper>
              <ButtonWrapper>
                {ele.ownerComment &&
                ele.ownerComment !== '삭제된 댓글입니다.' ? (
                  <CancelButton onClick={() => onDeleteComment(ele)}>
                    삭제
                  </CancelButton>
                ) : (
                  <>
                    {selectedIndex === idx && (
                      <CancelButton onClick={onClickCancel}>취소</CancelButton>
                    )}

                    <RegisterButton
                      onClick={() => {
                        if (selectedIndex === idx) {
                          onAddComment(ele, comment)
                          onReset()
                        } else {
                          onReset()
                        }
                      }}
                    >
                      등록
                    </RegisterButton>
                  </>
                )}
                {/* {ele.ownerComment &&
                ele.ownerComment !== '삭제된 댓글입니다.' ? (
                  <div onClick={() => onDeleteComment(ele)}>삭제</div>
                ) : (
                  <>
                    <div onClick={onClickCancel}>취소</div>
                    <div
                      onClick={() => {
                        onAddComment(ele, comment)
                        onReset()
                      }}
                    >
                      등록
                    </div>
                  </>
                )} */}
              </ButtonWrapper>
            </ReviewWrapper>
          ))}
      </ReviewContainer>

      <Paging
        page={page}
        count={total}
        setPage={(e) => changePage(e)}
        isTemp={true}
        tableSize={10}
        marginTop={[40, 40]}
      />
    </>
  )
}

export default ReviewItem

const ReviewContainer = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;
  margin-top: 20px;

  border-top-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: ${colors.G3};

  @media ${(props) => props.theme.mobile} {
    margin-top: 10px;
    border-top-width: 0px;
    border-bottom-width: 0px;
  }

  position: relative;
`

const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;

  border-bottom-width: ${(props) => (props.isLast ? '0px' : '1px')};
  border-style: solid;
  border-color: ${colors.W4};

  @media ${(props) => props.theme.mobile} {
    padding: ${(props) => (props.isLast ? `23px 20px 0` : `23px 20px 20px`)};
    border-color: ${colors.G3};
    border-bottom-width: ${(props) => (props.isLast ? '0px' : '5px')};
  }
`

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  padding-top: 5px;

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    padding-top: 0px;
  }
`

const WriterInfo = styled.div`
  color: ${colors.BK};
  font-weight: 700;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const StarTimeInfo = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;

  @media ${(props) => props.theme.mobile} {
    align-items: flex-end;
  }
`

const TimeInfo = styled.div`
  margin-top: 22px;
  color: ${colors.G4};
  font-size: 16px;

  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`

const TimeInfoMo = styled.div`
  color: ${colors.G4};
  font-size: 14px;
  margin-left: 7px;
  display: none;

  @media ${(props) => props.theme.mobile} {
    display: flex;
  }
`

const MenuInfo = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: ${colors.mainG};
  padding-right: 10px;
  line-height: normal;

  @media ${(props) => props.theme.mobile} {
    margin-top: 18px;
    margin-bottom: 20px;
    font-size: 14px;
    padding-right: 0px;
  }
`

const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media ${(props) => props.theme.tablet} {
    padding: 0;
  }
`

const UserComment = styled.div`
  margin-bottom: 20px;
  color: black;
`

const OwnerComment = styled.div``

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  @media ${(props) => props.theme.tablet} {
    padding: 0;
  }

  /* div {
    width: 155px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;

    @media ${(props) => props.theme.mobile} {
      flex: 1;
      font-size: 14px;
    }
  }

  div:nth-child(1) {
    border: 1px solid ${colors.G3};
  }

  div:nth-child(2) {
    margin-left: 10px;
    background-color: ${colors.mainG};
    color: ${colors.W1};
  } */
`

const CancelButton = styled.div`
  width: 155px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${colors.G3};

  @media ${(props) => props.theme.mobile} {
    flex: 1;
    font-size: 14px;
  }
`

const RegisterButton = styled.div`
  width: 155px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${colors.mainG};
  color: ${colors.W1};

  @media ${(props) => props.theme.mobile} {
    flex: 1;
    font-size: 14px;
  }
`

const InputReview = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  position: relative;
`

const TextInputReview = styled.textarea`
  min-height: 145px;
  padding: 20px 15px 35px;
  scroll-padding: 35px;
  width: 100%;
  border: ${(props) =>
    props.focusIdx ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  border-radius: 8px;
  background-color: transparent;
  resize: none;
  outline: none;
  overflow: hidden;
  font-size: 16px;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
    padding: 20px 20px 35px;
    min-height: 180px;
  }
`

const InfoInputReview = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
  font-size: 14px;
  color: ${colors.G4};

  span:nth-child(1) {
    display: ${(props) => (props.isFocus ? 'none' : 'flex')};
  }

  span:nth-child(2) {
    margin-top: 8px;
  }

  @media ${(props) => props.theme.tablet} {
    padding-left: 15px;
  }

  @media ${(props) => props.theme.mobile} {
    font-size: 12px;

    span:nth-child(2) {
      margin-top: 7px;
    }
  }
`

const LimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  h1 {
    color: ${colors.BK};
  }
`

const PrintReview = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.W4};
  width: 100%;
  margin-bottom: 20px;
  border-radius: 8px;
  position: relative;
`

const TextPrintReview = styled.div`
  padding: 20px 15px;
  min-height: 145px;
  word-break: break-all;
  white-space: pre-wrap;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
    padding: 20px;
    min-height: 180px;
  }
`

const TimePrintReview = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  font-size: 14px;
  color: ${colors.G4};

  @media ${(props) => props.theme.mobile} {
    font-size: 12px;
  }
`
